var map = {
	"./angular-logo.svg": "57ea",
	"./angularjs-logo.svg": "410a",
	"./arrow.svg": "b94f",
	"./avatar.png": "1195",
	"./back.svg": "ccfe",
	"./bag.svg": "57b7",
	"./cancel.svg": "f687",
	"./cards/isometric.jpg": "9b1f",
	"./cards/lifestyle.jpg": "58a5",
	"./cards/mountains.jpeg": "6253",
	"./cards/rns.png": "b577",
	"./chat/1.png": "c755",
	"./chat/2.png": "fd98",
	"./chat/3.png": "a5a2",
	"./chat/4.png": "35d7",
	"./chat/5.png": "cd22",
	"./chat/6.png": "6d0d",
	"./chat/7.png": "f4d7",
	"./chat/8.png": "cf6e",
	"./chat/9.png": "8b77",
	"./chat/awesome-meme.jpg": "0994",
	"./chat/chat-screen.png": "31df",
	"./chat/download.svg": "35d1d",
	"./chat/files.svg": "0843",
	"./chat/images.svg": "ad27",
	"./chat/information.svg": "9c54",
	"./chat/links.svg": "0aee",
	"./chat/notifications.svg": "fff1",
	"./chat/people.svg": "7308",
	"./check.svg": "f222",
	"./documentation/dribble-logo.svg": "cd08",
	"./documentation/facebook-logo.svg": "2c0a",
	"./documentation/github-logo.svg": "02fd",
	"./documentation/instagram-logo.svg": "cae8",
	"./documentation/linkedin-logo.svg": "44de",
	"./documentation/sing-screenshot.jpg": "3d29",
	"./documentation/twitter-logo.svg": "8aa2",
	"./icons/archive.svg": "8238",
	"./icons/arrow-down-blue.svg": "24f7",
	"./icons/arrow-down-second.svg": "92db",
	"./icons/arrow-down.svg": "c874",
	"./icons/bell-blue.svg": "5286",
	"./icons/bell.svg": "3d56",
	"./icons/browser-blue.svg": "c4a5",
	"./icons/browser-grey.svg": "20f7",
	"./icons/browser-seven.svg": "91fa",
	"./icons/browser-third.svg": "b8e2",
	"./icons/browser-white.svg": "871e",
	"./icons/browser.svg": "9dca",
	"./icons/calendar-blue.svg": "2c39",
	"./icons/calendar-white.svg": "fda0",
	"./icons/calendar.svg": "b8bd",
	"./icons/close-blue.svg": "cf11",
	"./icons/close-second.svg": "5906",
	"./icons/close.svg": "8b1b",
	"./icons/copy-blue.svg": "a3bc",
	"./icons/copy-grey.svg": "3931",
	"./icons/copy-seven.svg": "ee89",
	"./icons/copy-third.svg": "b363",
	"./icons/copy-white.svg": "d787",
	"./icons/copy.svg": "8aac",
	"./icons/cube-blue.svg": "9e2c",
	"./icons/cube.svg": "e952",
	"./icons/email-blue.svg": "3d83",
	"./icons/email-grey.svg": "cc94",
	"./icons/email-seven.svg": "7dde",
	"./icons/email-third.svg": "8e14",
	"./icons/email-white.svg": "0e79",
	"./icons/email.svg": "43be",
	"./icons/file-text-blue.svg": "e1d6",
	"./icons/file-text-grey.svg": "8458",
	"./icons/file-text-white.svg": "b127",
	"./icons/file-text.svg": "aac1",
	"./icons/fire-blue.svg": "f403",
	"./icons/fire-grey.svg": "d5d2",
	"./icons/fire-seven.svg": "4cf5",
	"./icons/fire-third.svg": "81be",
	"./icons/fire-white.svg": "b1d0",
	"./icons/fire.svg": "62e5",
	"./icons/flip-blue.svg": "58f6",
	"./icons/flip-second.svg": "d363",
	"./icons/flip.svg": "bb9a",
	"./icons/grid-blue.svg": "3140",
	"./icons/grid-grey.svg": "704f",
	"./icons/grid-seven.svg": "aeb1",
	"./icons/grid-third.svg": "dd96",
	"./icons/grid-white.svg": "3703",
	"./icons/grid.svg": "4b05",
	"./icons/home-blue.svg": "2de3",
	"./icons/home-grey.svg": "6a80",
	"./icons/home-seven.svg": "53cc",
	"./icons/home-third.svg": "df59",
	"./icons/home-white.svg": "ec0b",
	"./icons/home.svg": "ac9d",
	"./icons/keypad-blue.svg": "61a0",
	"./icons/keypad-grey.svg": "e93a",
	"./icons/keypad-seven.svg": "80d6",
	"./icons/keypad-third.svg": "ef06",
	"./icons/keypad-white.svg": "ca63",
	"./icons/keypad.svg": "60ff",
	"./icons/layers-blue.svg": "7f8e",
	"./icons/layers-grey.svg": "259f",
	"./icons/layers-seven.svg": "ce03",
	"./icons/layers-third.svg": "1fe3",
	"./icons/layers-white.svg": "0580",
	"./icons/layers.svg": "626a3",
	"./icons/layout-blue.svg": "ec7f",
	"./icons/layout-grey.svg": "7295",
	"./icons/layout-seven.svg": "1a74",
	"./icons/layout-third.svg": "89bc",
	"./icons/layout-white.svg": "7abc",
	"./icons/layout.svg": "be29",
	"./icons/list-blue.svg": "8e738",
	"./icons/list-grey.svg": "632c",
	"./icons/list-third.svg": "826a",
	"./icons/list-white.svg": "b173",
	"./icons/list.svg": "99ad",
	"./icons/menu-blue.svg": "e3e3",
	"./icons/menu-second.svg": "082d",
	"./icons/menu.svg": "d17f",
	"./icons/message-circle-blue.svg": "ed4a",
	"./icons/message-circle-grey.svg": "f2f2",
	"./icons/message-circle-seven.svg": "05d1",
	"./icons/message-circle-third.svg": "aae9",
	"./icons/message-circle-white.svg": "aaa6",
	"./icons/message-circle.svg": "6c61",
	"./icons/person-blue.svg": "5df3d",
	"./icons/person-grey.svg": "22b8",
	"./icons/person-seven.svg": "b9ac",
	"./icons/person-third.svg": "ba46",
	"./icons/person-white.svg": "f941",
	"./icons/person.svg": "d104",
	"./icons/pie-chart-blue.svg": "7912",
	"./icons/pie-chart-grey.svg": "7499",
	"./icons/pie-chart-seven.svg": "560f",
	"./icons/pie-chart-third.svg": "199f",
	"./icons/pie-chart-white.svg": "cec9",
	"./icons/pie-chart.svg": "9773",
	"./icons/pin-blue.svg": "8298",
	"./icons/pin-grey.svg": "aa9b",
	"./icons/pin-seven.svg": "9c2b",
	"./icons/pin-third.svg": "2452",
	"./icons/pin-white.svg": "5934",
	"./icons/pin.svg": "862b",
	"./icons/power.svg": "111a",
	"./icons/search-2-blue.svg": "e681",
	"./icons/search-2-second.svg": "2baa",
	"./icons/search-2.svg": "81ce",
	"./icons/settings-10-blue.svg": "0203",
	"./icons/settings-10-second.svg": "e479",
	"./icons/settings-10.svg": "921f",
	"./icons/shopping-bag-blue.svg": "0136",
	"./icons/shopping-bag-grey.svg": "8a50",
	"./icons/shopping-bag-seven.svg": "ebae",
	"./icons/shopping-bag-third.svg": "ea27",
	"./icons/shopping-bag-white.svg": "75dd",
	"./icons/shopping-bag.svg": "38f3",
	"./icons/text-blue.svg": "9d14",
	"./icons/text.svg": "d36f",
	"./invoice-logo.png": "6d97",
	"./js-logo.svg": "44df",
	"./loadingfish.gif": "f086",
	"./login-img.jpg": "6aab",
	"./logo-e-sea-black.png": "5676",
	"./logo-kkp2.png": "18d3",
	"./logo.png": "cf05",
	"./logo_new_v3.png": "a727",
	"./microsoft.png": "70ce",
	"./payments/aexpress.svg": "8430",
	"./payments/mastercard.svg": "8595",
	"./payments/paypal.svg": "6f3e",
	"./payments/visa.svg": "6d67",
	"./people/a1.jpg": "c279",
	"./people/a2.jpg": "413d",
	"./people/a3.jpg": "6e3e",
	"./people/a4.jpg": "15c9",
	"./people/a5.jpg": "9dd7",
	"./people/a6.jpg": "ff55",
	"./people/a7.png": "78ed",
	"./pictures/1.jpg": "2a37",
	"./pictures/10.jpg": "ebc0",
	"./pictures/11.jpg": "0f58",
	"./pictures/13.jpg": "ce27",
	"./pictures/14.jpg": "1fa7",
	"./pictures/15.jpg": "0ab9",
	"./pictures/16.jpg": "52a0",
	"./pictures/17.jpg": "41ab",
	"./pictures/18.jpg": "7b12",
	"./pictures/19.jpg": "d3f5",
	"./pictures/2.jpg": "9428",
	"./pictures/20.jpg": "0199",
	"./pictures/21.jpg": "b56f",
	"./pictures/3.jpg": "23bd",
	"./pictures/4.jpg": "c946",
	"./pictures/5.jpg": "9991",
	"./pictures/6.jpg": "f062",
	"./pictures/7.jpg": "c2a9",
	"./pictures/8.jpg": "e837",
	"./pictures/9.jpg": "f863",
	"./products/1.png": "8369",
	"./products/2.png": "d399",
	"./products/3.png": "3614",
	"./products/4.png": "ebb4",
	"./products/5.png": "d234",
	"./products/6.png": "1769",
	"./products/img1.jpg": "d1b6",
	"./react-logo.svg": "fc51",
	"./search/1.jpg": "9e28",
	"./search/13.jpg": "7670",
	"./search/3.jpg": "f198",
	"./search/5.jpg": "f64f",
	"./search/8.jpg": "3ee5",
	"./send.svg": "ad0d",
	"./sidebar/Fill/Caret down.svg": "ae4f",
	"./sidebar/Fill/Cross.svg": "8f61",
	"./sidebar/Fill/Exchange.svg": "6779",
	"./sidebar/Fill/Menu.svg": "ee29",
	"./sidebar/Fill/Search.svg": "3074",
	"./sidebar/Outline/Add.svg": "4fbc",
	"./sidebar/Outline/Apps.svg": "7cb1",
	"./sidebar/Outline/Bank.svg": "ca07",
	"./sidebar/Outline/Cancel.svg": "2926",
	"./sidebar/Outline/Chart-pie-alt.svg": "d5be",
	"./sidebar/Outline/Chat.svg": "3c4b",
	"./sidebar/Outline/Columns.svg": "3122",
	"./sidebar/Outline/Document.svg": "3a89",
	"./sidebar/Outline/Envelope.svg": "064c",
	"./sidebar/Outline/Fire.svg": "592b",
	"./sidebar/Outline/Home.svg": "5483",
	"./sidebar/Outline/Image.svg": "70d0",
	"./sidebar/Outline/Layout.svg": "8149",
	"./sidebar/Outline/Location.svg": "e1f1",
	"./sidebar/Outline/Menu.svg": "38fd8",
	"./sidebar/Outline/Rows.svg": "675b",
	"./sidebar/Outline/Settings-adjust.svg": "46a7",
	"./sidebar/Outline/Settings-alt.svg": "787b",
	"./sidebar/Outline/Settings.svg": "cba0",
	"./sidebar/Outline/Shopping-cart.svg": "9050",
	"./sidebar/Outline/Stack.svg": "e50d6",
	"./sidebar/Outline/User.svg": "eb42",
	"./slides/slide-1.jpg": "8d46",
	"./slides/slide-2.jpg": "fca0a",
	"./slides/slide-3.jpg": "5f59",
	"./stars/star-filled.svg": "9322",
	"./stars/star.svg": "06ef",
	"./support-agent.png": "8a7b",
	"./tables/1.jpg": "6f89",
	"./tables/2.jpg": "b6fc",
	"./tables/3.jpg": "0c60",
	"./tables/4.jpg": "5594",
	"./tables/5.jpg": "37cf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";